import React from 'react';
interface WordmarkProps {
  submark?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  align?: 'left' | 'center';
  rule?: boolean;
  className?: string;
}
const sizeMap = {
  sm: {
    main: 'text-2xl md:text-3xl',
    sub: 'text-base md:text-lg',
    spacing: 'tracking-[0.35em]',
    gap: 'mt-2'
  },
  md: {
    main: 'text-4xl md:text-5xl',
    sub: 'text-xl md:text-2xl',
    spacing: 'tracking-[0.4em]',
    gap: 'mt-3'
  },
  lg: {
    main: 'text-6xl md:text-7xl',
    sub: 'text-2xl md:text-3xl',
    spacing: 'tracking-[0.45em]',
    gap: 'mt-4'
  },
  xl: {
    main: 'text-7xl md:text-8xl lg:text-9xl',
    sub: 'text-3xl md:text-4xl',
    spacing: 'tracking-[0.5em]',
    gap: 'mt-4 md:mt-6'
  }
};
export function Wordmark({
  submark,
  size = 'lg',
  align = 'left',
  rule = false,
  className = ''
}: WordmarkProps) {
  const s = sizeMap[size];
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return <div className={`flex flex-col ${alignment} ${className}`} data-id="element-125" data-mp="zb2g9jyevh3t">
      {/* The wide-tracked V E R A wordmark. The trailing right-pad cancels the
            tracking on the last letter so the optical centering reads true. */}
      <div className={`font-serif font-light leading-none text-ink ${s.main} ${s.spacing} pr-[0.5em] -mr-[0.5em]`} aria-label="VERA" data-id="element-126" data-mp="zm2n7bxbu7zv">
        VERA
      </div>

      {submark && <div className={`font-serif italic font-light text-ink/90 ${s.sub} ${s.gap} leading-none`} data-id="element-127" data-mp="qm5u8y3wmmz0">
          {submark}
        </div>}

      {rule && <div className="mt-6 h-px w-16 bg-brass" aria-hidden="true" data-id="element-128" data-mp="gw46k7fgr6km" />}
    </div>;
}